import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M23.53 2.51263C23.679 2.67471 23.7972 2.86726 23.8778 3.07925C23.9585 3.29124 24 3.51849 24 3.74801C24 3.97752 23.9585 4.20478 23.8778 4.41677C23.7972 4.62875 23.679 4.8213 23.53 4.98339L9.13296 20.6874C8.98437 20.8499 8.80784 20.9788 8.6135 21.0668C8.41915 21.1547 8.21081 21.2 8.00039 21.2C7.78998 21.2 7.58164 21.1547 7.38729 21.0668C7.19295 20.9788 7.01642 20.8499 6.86782 20.6874L0.469125 13.7078C0.168749 13.3802 0 12.9358 0 12.4724C0 12.0091 0.168749 11.5647 0.469125 11.2371C0.769502 10.9094 1.1769 10.7254 1.6017 10.7254C2.02649 10.7254 2.43389 10.9094 2.73427 11.2371L8.00039 16.9847L21.2649 2.51263C21.4135 2.35013 21.59 2.22121 21.7844 2.13324C21.9787 2.04528 22.1871 2 22.3975 2C22.6079 2 22.8162 2.04528 23.0106 2.13324C23.2049 2.22121 23.3814 2.35013 23.53 2.51263Z' />
        </SvgIcon>
    );
});
